( function ( $ ) {
document.addEventListener ( 'DOMContentLoaded', function( event ) {
  const tableCourses = $( '#courses-table' );
  if (tableCourses.length) {
    tableCourses.DataTable( {
      lengthMenu: [ [10, 25, 50, -1], [10, 25, 50, "Tudo"] ],
      dom: 'Bfrtip',
      buttons: [
        'excel', 'pageLength'
      ],
      ajax: {
        url: '/wp-admin/admin-ajax.php?action=lds_get_table_information'
      },
      ordering: false,
      serverSide: true,
      language: {
        'url': globalVars.datatables
      },
      columns: [
        { data: 'id' },
        { data: 'nome' },
        { data: 'created' },
        { data: 'total' },
        { data: 'not_started' },
        { data: 'in_progress' },
        { data: 'completed' },
        { data: 'tests_average' },
        { data: 'completed_average' },
        { data: 'detail' }
      ]
    } );
  }
});
} ) ( jQuery );
